export type SignalRInfo = {
  url: string;
  accessToken: string;
};

export enum HubType {
  ConversationHub = "ConversationHub",
  UploadHub = "UploadHub",
  NotificationHub = "NotificationHub",
}

import { RestClient } from "./restClient";
import RestResponse from "../models/client/RestResponse.ts";
import RequestMethod from "../models/client/RequestMethod.ts";

export type SetContextRequest = {
  sessionId: string;
  connectionId: string | null;
  hub: HubType;
};

export type NetgotiateServiceType = {
  negotiate: (hub: HubType) => RestResponse<SignalRInfo>;
  setContext: (request: SetContextRequest) => RestResponse<SignalRInfo>;
};

const negotiateServices = (
  client: RestClient,
  path: string
): NetgotiateServiceType => ({
  negotiate: async (hub: HubType) =>
    await client.fetch<SignalRInfo>(RequestMethod.POST, `${path}`, {
      hubId: hub,
    }),
  setContext: async (request: SetContextRequest) =>
    await client.fetch<SignalRInfo>(RequestMethod.POST, `${path}/setContext`, {
      sessionId: request.sessionId,
      connectionId: request.connectionId,
      hubId: request.hub,
    }),
});

export default negotiateServices;
